import type { AskedQuestion } from '@inference.engine/agentic/human-input';
import { AskedQuestions as AskedQuestionsBlock } from '@inference.engine/agentic-ui/components';
import { AgenticUiText } from '@/shared/i18n/AgenticUiText';

/** What the agent asked in this reply, in the block the builder's test chat draws. */
export function ChatAskedQuestions({ items }: { items: readonly AskedQuestion[] }) {
  return (
    <AgenticUiText>
      <div className="mb-sm flex flex-col gap-xs">
        <AskedQuestionsBlock items={items} />
      </div>
    </AgenticUiText>
  );
}
